var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 12,
    fill: "#5B4593"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13C10 11.3431 11.3431 10 13 10H25C26.6569 10 28 11.3431 28 13V25C28 26.6569 26.6569 28 25 28H13C11.3431 28 10 26.6569 10 25V13ZM21.3013 15.8865L18.7113 13.2965C18.0813 12.6665 17.0012 13.1065 17.0012 13.9965V19.1765C17.0012 20.0665 18.0813 20.5165 18.7113 19.8865L21.3013 17.2965C21.6912 16.9065 21.6912 16.2765 21.3013 15.8865ZM13 23C12.4477 23 12 23.4477 12 24C12 24.5523 12.4477 25 13 25H21C21 25.5523 21.4477 26 22 26C22.5523 26 23 25.5523 23 25H25C25.5523 25 26 24.5523 26 24C26 23.4477 25.5523 23 25 23H23C23 22.4477 22.5523 22 22 22C21.4477 22 21 22.4477 21 23H13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon_video.9369ea45de78003558206b2f48813373.svg";
export { ForwardRef as ReactComponent };